export const CONTAINER_VARIANTS = {
  // Outer shell: 100% (md and below) → 1360 (lg/xl) → 1440 (xxl)
  container: [
    'mx-auto w-full max-w-full',
    '[@media_(min-width:1280px)_and_(max-width:1919px)]:max-w-[1360px]', // lg + xl
    '[@media_(min-width:1920px)]:max-w-[1440px]' // xxl
  ].join(' '),

  // Inner content: 100% (xs/xxs) → 768 (sm) → 856 (md/lg) → 1056 (xl) → 1200 (xxl)
  content: [
    'mx-auto w-full max-w-full',
    '[@media_(min-width:600px)_and_(max-width:1023px)]:max-w-[768px]', // sm
    '[@media_(min-width:1024px)_and_(max-width:1439px)]:max-w-[856px]', // md + lg
    '[@media_(min-width:1440px)_and_(max-width:1919px)]:max-w-[1056px]', // xl
    '[@media_(min-width:1920px)]:max-w-[1200px]' // xxl
  ].join(' '),

  // No cap
  full: 'w-full'
};
